import React, { useCallback, useState } from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives/compiled';
import Toggle from '@atlaskit/toggle';
import { token } from '@atlaskit/tokens';

import { overrideGate, studioFg } from '../../../common/persistance';

const styles = cssMap({
	appSwitcherToggleContainer: {
		marginTop: token('space.150'),
		marginBottom: token('space.150'),
	},
});

export const StudioAppSwitcherToggle = ({
	updateOverrides,
}: {
	updateOverrides: () => void;
}): React.JSX.Element => {
	const [isStudioAppV1, setIsStudioAppV1] = useState(studioFg('toggle-studio-v1'));

	const onStudioAppV1Change = useCallback(() => {
		overrideGate('toggle-studio-v1', !isStudioAppV1);
		setIsStudioAppV1(!isStudioAppV1);

		updateOverrides();
	}, [isStudioAppV1, updateOverrides]);

	return (
		<>
			<Heading size="small" as="h4">
				Toggle Studio V1
			</Heading>
			<Box xcss={styles.appSwitcherToggleContainer}>
				<Toggle
					label="Enable Studio App V1"
					isChecked={isStudioAppV1}
					onChange={onStudioAppV1Change}
				/>
			</Box>
		</>
	);
};
